<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="7" lg="5" xl="4" class="text-center">
        <v-card>
          <v-card-text class="text-right">
            <v-img
              :src="require('@/assets/logo.png')"
              class="my-3"
              contain
              height="100"
            ></v-img>
            <v-form v-model="isValidForm" ref="forgotForm">
              <v-row>
                <v-col cols="12" align="center">
                  <h3>Password Reset Request</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Username"
                    v-model="userName"
                    :rules="[required('Username')]"
                    required
                    placeholder="Please enter the username registered in the system"
                    persistent-placeholder
                    outlined
                    @keydown.enter.native="handleResetPassword"
                  />
                </v-col>
              </v-row>
              <v-row justify="end">
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    color="primary"
                    :disabled="!isValidForm"
                    @click="handleResetPassword"
                  >
                    Reset Password
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    block
                    outlined
                    depressed
                    @click="goToLogin"
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { required } from '@/lib/formValidations'
import { loginRoute } from '@/lib/constants/routes'

export default {
  data () {
    return {
      isValidForm: null,
      userName: null,
      password: null
    }
  },
  computed: {
    ...mapFields('application', [
      'showDrawer'
    ])
  },
  methods: {
    required,
    ...mapActions('authentication', [
      'resetPassword'
    ]),
    goToLogin () {
      this.$router.push(loginRoute.url)
    },
    handleResetPassword () {
      if (!this.$refs.forgotForm.validate()) {
        return
      }

      this.resetPassword({ emailAddress: this.userName }).then(() => {
        this.$router.push(loginRoute.url)
      })
    }
  }
}
</script>
